import React from 'react';
import DatePicker from 'react-datepicker';
import { Field } from 'react-final-form';
import { isAfter, isValid } from 'date-fns';

import { FormFeedback } from './index';

import 'react-datepicker/dist/react-datepicker.css';
import './FormDateInput.scss';

const renderDateInput = ({
  input,
  meta,
  inputOnChange,
  dateFormat,
  screenDimensions,
  disabled,
  id
}) => {
  const dateInputProps = {
    ...input,
    value: input.value ? new Date(input.value) : null,
    onChange: e => {
      input.onChange(e);
      inputOnChange && inputOnChange(e);
    }
  };

  return (
    <React.Fragment>
      <DatePicker
        {...dateInputProps}
        id={id}
        disabled={disabled}
        placeholderText="Select a date"
        className="form-input__control date-input"
        selected={
          dateInputProps.value && isValid(new Date(dateInputProps.value))
            ? new Date(dateInputProps.value)
            : null
        }
        dateFormat={dateFormat}
        withPortal={screenDimensions.width <= 1023}
        dayClassName={date =>
          dateInputProps.name !== 'dueDate' && isAfter(date, new Date())
            ? 'date-input__disabled'
            : undefined
        }
      />

      {meta.error && (meta.touched || meta.dirty) && (
        <FormFeedback positive={false}>{meta.error}</FormFeedback>
      )}
    </React.Fragment>
  );
};

export default props => {
  const { name, initialValue, validate, labelRenderer, dateFormat, disabled } = props;

  const screenDimensions = {
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768
  };

  return (
    <div>
      {labelRenderer && (
        <label className="form-input" htmlFor={name}>
          {typeof labelRenderer === 'function' ? labelRenderer() : labelRenderer}
        </label>
      )}

      <Field
        name={name}
        id={name}
        disabled={disabled}
        {...(initialValue !== undefined ? { initialValue: new Date(initialValue) } : {})}
        dateFormat={dateFormat}
        component={renderDateInput}
        screenDimensions={screenDimensions}
        validate={validate}
      />
    </div>
  );
};
